import * as React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientRecordAction } from "../../../ClientRecord/Action/ClientRecordAction";
import { PensionProtection as PensionProtectionForm } from "../../../ClientRecord/PensionProtection";

interface IPensionProtectionProps extends IProcessComponentProps {
    label: string;
}

interface IPensionProtectionState {
    isLightboxShow: boolean;
}

export class PensionProtection extends ProcessComponent<IPensionProtectionProps, IPensionProtectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLightboxShow: false,
        };
    }

    private resetPensionProtectionDetails(customerId) {
        const model = {
            PensionCreditProtectionDetails: null,
            PensionEnhancedProtectionDetails: null,
            PensionPrimaryProtectionDetails: null,
            PensionFixed2014ProtectionDetails: null,
            PensionFixed2016ProtectionDetails: null,
            PensionFixedProtectionDetails: null,
            PensionIndividual2014ProtectionDetails: null,
            PensionIndividual2016ProtectionDetails: null,
            PensionRelevantOverseasProtectionDetails: null,
            PensionSchemeSpecificProtectionDetails: null,
            PensionSevereIllHealthDeclarationDetails: null,
            PensionQropsProtectionDetails: null,
        };
        ClientRecordAction.savePensionProtection(customerId, model, (result) => {
            if (result.length == 0) {
                this.props.onChange({ PensionProtection: model });
            }
        });
    }

    private renderPensionProtection(data, onChange) {
        return (
            <RadiosEditor
                cssWrapper="radio-group rg-150 mb-16"
                label={"Does your client have any form of pension protection?"}
                selected={data?.HasPensionProtection}
                options={[true, false]}
                getText={(v) => (v ? "Yes" : "No")}
                onChange={(v) => {
                    if (!v) {
                        // selection is No, so need to reset all pension protection sub questions
                        this.resetPensionProtectionDetails(getQueryParameters()["customerid"]);
                    }
                    this.onDataChange(onChange, { HasPensionProtection: v }, data);
                    this.setState({ isLightboxShow: v });
                }}
                required={"Please select"}
            />
        );
    }

    private renderPensionProtectionForm() {
        const { data, onChange } = this.props;
        return (
            <Lightbox
                show={data.HasPensionProtection}
                title="Pension protection"
                onClose={() => {
                    this.setState({ isLightboxShow: false });
                }}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={true}
                cssWrapper="is-default-lightbox"
            >
                <PensionProtectionForm
                    id={getQueryParameters()["customerid"]}
                    callback={() => this.setState({ isLightboxShow: false })}
                    hideHeading={true}
                    onSaveBack={(result) => this.props.onChange({ PensionProtection: result })}
                    hideContainerClasses={true}
                    hasReadWriteAccess={true}
                />
            </Lightbox>
        );
    }

    public render(): JSX.Element {
        const { data, onChange, label } = this.props;
        return (
            <>
                {this.renderPensionProtection(data, onChange)}
                {data.HasPensionProtection && (
                    <button
                        className="edit-circle-icon-button"
                        title="Edit"
                        onClick={() => {
                            this.setState({ isLightboxShow: true });
                        }}
                    >
                        <span className="icon" aria-hidden={true}></span>
                        <span className="text">{label}</span>
                    </button>
                )}
                {this.state.isLightboxShow && this.renderPensionProtectionForm()}
            </>
        );
    }
}
